import type { User as SupabaseUser } from '@supabase/supabase-js'
import { DateTime } from 'luxon'

import type { ReservationData, ReservationRich, User } from '@/assets/composables/types'
import { PartOfDay } from '@/assets/composables/types'

export const mapSupabaseUser = (supabaseUser: SupabaseUser): User => ({
  id: supabaseUser.id,
  name:
    supabaseUser.user_metadata?.full_name ||
    supabaseUser.user_metadata?.name ||
    supabaseUser.email ||
    '',
  email: supabaseUser.email || '',
  registration: supabaseUser.created_at || '',
  prefs: supabaseUser.user_metadata || {},
})

export const ToReservation = (reservation: ReservationData): ReservationRich => {
  const reservationDate = DateTime.fromISO(reservation.date)
  return {
    id: reservation.id,
    date: reservationDate,
    timelineDate: {
      day: reservationDate.toFormat('dd'),
      month: reservationDate.toFormat('LLL').toUpperCase(),
    },
    partOfDay: {
      name: ToReadableTime(reservation.partOfDay, false),
      range: ToTimeRange(reservation.partOfDay),
    },
    cardReturned: reservation.cardReturned,
    cancelled: reservation.cancelled ?? false,
  }
}

const ToTimeRange = (time: PartOfDay): string[] => {
  // In case of need to change the time range, don't forget to change it on BE side, too
  switch (time) {
    case PartOfDay.morning:
      return ['00:00', '11:59']
    case PartOfDay.afternoon:
      return ['12:00', '23:59']
    case PartOfDay.allday:
      return ['00:00', '23:59']
    default:
      return []
  }
}

export const ToReadableTime = (time: PartOfDay | null, extended: boolean = true): string => {
  if (!time) return ''

  switch (time) {
    case PartOfDay.morning:
      return 'Dopoludnie' + (extended ? ` ${ToTimeRange(time).join(' – ')}` : '')
    case PartOfDay.afternoon:
      return 'Popoludnie' + (extended ? ` ${ToTimeRange(time).join(' – ')}` : '')
    case PartOfDay.allday:
      return 'Celý deň' + (extended ? ` ${ToTimeRange(time).join(' – ')}` : '')
    default:
      return ''
  }
}
